import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card, Grid, ODataTable, Formatter, OptionDropdown, Highlighter,
} from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

import { InputRicerca, PageWrapper } from 'dashboard';
import { stampaBarra4 } from 'apis/setteTrentaApi';
import TipoDichiarazione from 'enums/TipoDichiarazione';
import DettaglioBarra4 from './DettaglioBarra4';

function stampaTipo(tipo) {
  switch (tipo) {
    case TipoDichiarazione.SetteTrentaIntegrativaCodice1:
      return '1';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice2:
      return '2';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice3:
      return '3';
    default:
      return '';
  }
}

const CODICEFISCALEINPS = '80078750587';

function stampaStato(item) {
  if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta != ''
    && (item.Anno > 2019 || item.DatiAddizionali.CodiceFiscaleSostitutoImposta != CODICEFISCALEINPS)
    && (item.DatiAddizionali.DaTrattenere7304 == '0' && item.DatiAddizionali.DaRimborsare7304 == '0')) {
    return 'Importi a zero';
  } if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta == '') {
    return 'Senza sostituto';
  } if ((item.DatiAddizionali.DaTrattenere7304 != '0' || item.DatiAddizionali.DaRimborsare7304 != '0') && item.DatiAddizionali.Stato7304 == 'NonImpostato') {
    return 'Inviato A.E.';
  } if (item.DatiAddizionali.SenzaSostituto == 'False'
    && (item.Anno > 2019 || item.DatiAddizionali.CodiceFiscaleSostitutoImposta != CODICEFISCALEINPS) && item.DatiAddizionali.Stato7304 == 'Ok') {
    return "Reso disponibile al sostituto d'imposta";
  } if (item.DatiAddizionali.Stato7304 == 'Precontrolli') {
    return 'Controllo preventivo';
  } if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS && item.DatiAddizionali.Stato7304 == 'ScartoAE' && item.DatiAddizionali.Stato7304Info == 'NO' && item.DatiAddizionali.DataInvioPostel == '') {
    return 'Non disponibile';
  } if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS && item.DatiAddizionali.Stato7304 == 'ScartoAE' && item.DatiAddizionali.Stato7304Info == 'NO' && item.DatiAddizionali.DataInvioPostel != '') {
    return 'Postel';
  } if ((item.DatiAddizionali.Stato7304 == 'ScartoAE' && (item.DatiAddizionali.Stato7304Info == 'CF' || item.DatiAddizionali.Stato7304Info == 'CV'))) {
    return 'Scartato Sostituto';
  } if (item.DatiAddizionali.Stato7304 == 'ScartoInps') {
    return 'Scartato I.N.P.S.';
  } if (item.DatiAddizionali.Stato7304 == 'Ok' && item.DatiAddizionali.CodiceFiscaleSostitutoImposta == CODICEFISCALEINPS) {
    return "Abbinata dall'I.N.P.S.";
  }
  return '';
}

class RigaContribuente extends Component {
  state = {
    mostraModaleDettaglio: false,
  }

  stampa = () => {
    const { item } = this.props;

    stampaBarra4([item]).then((resp) => {
      if (!resp.Success) {
        SnackbarManager.notifyError(resp.DetectedProblems);
      } else {
        SnackbarManager.startDeterminateAsyncTask(resp.CorrelationId, 'Creazione pdf in corso', 1);
      }
    });
  }

  apriDettaglio = () => {
    this.setState({ mostraModaleDettaglio: true });
  }

  chiudiModaleDettaglio = () => {
    this.setState({ mostraModaleDettaglio: false });
  }

  render() {
    const {
      additionalRowData,
      item,
      annoSelezionato,
    } = this.props;
    const {
      mostraModaleDettaglio,
    } = this.state;

    return (
      <tr key={item.CodiceFiscale}>
        <td>
          <Highlighter text={item.Cognome} value={additionalRowData.searchTerm} /> <Highlighter text={item.Nome} value={additionalRowData.searchTerm} />
        </td>
        <td><Highlighter text={item.CodiceFiscale} value={additionalRowData.searchTerm} /></td>
        <td>{item.DatiAddizionali.Congiunta == 'True' && <SuccessoIcon className="icon-success" />}</td>
        <td>{stampaTipo(item.Tipo)}</td>
        <td>{stampaStato(item)}</td>
        <td className="text--right">{item.DatiAddizionali.Rate7304}</td>
        <td className="text--right">&euro; {item.DatiAddizionali.DaTrattenere7304}</td>
        <td className="text--right">&euro; {item.DatiAddizionali.DaRimborsare7304}</td>
        <td><Formatter tipo="date" valore={item.DatiAddizionali.DataTrasmissione} /></td>
        <td>
          <OptionDropdown>
            {item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS
              && item.DatiAddizionali.DenominazioneSostitutoImposta != '' && item.DatiAddizionali.Stampa7304Abilitata === 'True' && <OptionDropdown.Item onClick={this.stampa}>Stampa /4</OptionDropdown.Item>}
            <OptionDropdown.Item onClick={this.apriDettaglio}>Dettaglio</OptionDropdown.Item>
          </OptionDropdown>
        </td>
        <DettaglioBarra4
          idDichiarazione={item.IdDichiarazione}
          showModal={mostraModaleDettaglio}
          onChiudi={this.chiudiModaleDettaglio}
          annoSelezionato={item.Anno}
        />
      </tr>
    );
  }
}

class Sostituto extends Component {
  state = {
    dichiarazioni: [],
    searchTerm: '',
    selezionati: [],
  }

  ricaricaTabella = () => {
    setTimeout(() => {
      this.dataTable && this.dataTable.loadPage();
    }, 1500);
  }

  onClickCerca = (searchTerm) => {
    this.setState({ searchTerm: searchTerm.trim() }, () => {
      this.dataTable && this.dataTable.loadPage();
    });
  }

  render() {
    const {
      ufficioSelezionato,
      utente,
      annoSelezionato,
    } = this.props;

    const {
      selezionati,
      searchTerm,
    } = this.state;

    return (
      <PageWrapper
        helmetTitle={`Sostituto ${this.props.match.params.nomeSostituto}`}
        pageTitle={`Sostituto ${this.props.match.params.nomeSostituto}`}
        pageBack
        onPageBack={() => { this.props.history.goBack(); }}
      >
        <Grid fluid className="pl-0 pr-0">
          <Grid.Row>
            <Grid.Col md="12">
              <Card title={<span>Sostituto {this.props.match.params.nomeSostituto}</span>}>
                <Grid.Row>
                  <Grid.Col md="5">
                    <InputRicerca onClickCerca={this.onClickCerca} />
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col md="12">
                    <ODataTable
                      hover
                      url={`/SetteTrenta/CercaContribuenti7304?searchTerm=${searchTerm}&ufficio=${ufficioSelezionato.CodiceUfficio}&sostituto=${this.props.match.params.cfSostituto}&anno=${annoSelezionato}`}
                      row={RigaContribuente}
                      ref={r => this.dataTable = r}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                      additionalRowData={{ searchTerm }}
                      annoSelezionato={annoSelezionato}
                    >
                      <ODataTable.Column>Dichiarante</ODataTable.Column>
                      <ODataTable.Column className="w-180">CF Dichiarante</ODataTable.Column>
                      <ODataTable.Column>Congiunta</ODataTable.Column>
                      <ODataTable.Column>Int.</ODataTable.Column>
                      <ODataTable.Column>Stato</ODataTable.Column>
                      <ODataTable.Column className="text--right">Rateazione</ODataTable.Column>
                      <ODataTable.Column className="text--right">Trattenuto</ODataTable.Column>
                      <ODataTable.Column className="text--right">Rimborsato</ODataTable.Column>
                      <ODataTable.Column>Data Trasmissione</ODataTable.Column>

                      <ODataTable.Column className="w-40" />
                    </ODataTable>
                  </Grid.Col>
                </Grid.Row>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStoreToProps = store => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
  utente: store.utente.profilo,
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

Sostituto.propTypes = {
  ufficioSelezionato: PropTypes.object,
  utente: PropTypes.object,
};

export default connect(mapStoreToProps)(Sostituto);
